import React from 'react';
import Picture from '../Shared/Picture';

const ArticleImageCenter = (props) => {
        const {Description, ShadowColour, Image, ImageAlt, ButtonText, ButtonUrl} = props.article;

    return (
        <React.Fragment>
            <div dangerouslySetInnerHTML={{"__html": Description.Value }} />
            <div className={ShadowColour.Value === "none" ? "teaser-media" : "teaser-media shadow shadow-blue"}>
                <Picture
                    mobileWidth="350"
                    mobileHeight="350"
                    src={Image.Value}
                    alt={ImageAlt.Value}
                    visibleByDefault={props.index === 0}
                />
                {ButtonUrl.Value ? <a className="buy-now-button" href={ButtonUrl.Value} target="_blank">{ButtonText.Value}</a> : null}
            </div>
        </React.Fragment>
    )
}

export default ArticleImageCenter;
